document.addEventListener("DOMContentLoaded", () => {

    const modal = document.getElementById("nava-enquiry-modal");

    if (!modal) return;

    const overlay = modal.querySelector(".nava-modal-overlay");
    const closeButton = modal.querySelector(".nava-modal-close");

    const title = document.getElementById("nava-product-title");
    const model = document.getElementById("nava-product-model");

    const hiddenTitle = document.getElementById("nava-hidden-product");
    const hiddenModel = document.getElementById("nava-hidden-model");
    const hiddenURL = document.getElementById("nava-hidden-url");

    const nameField = document.getElementById("nava-name");

    let activeButton = null;

    function openModal(button){

        activeButton = button;

        const productTitle = button.dataset.productTitle || "";
        const productModel = button.dataset.productModel || "";
        const productURL = button.dataset.productUrl || "";

        title.textContent = productTitle;
        model.textContent = productModel || "Not supplied";

        hiddenTitle.value = productTitle;
        hiddenModel.value = productModel;
        hiddenURL.value = productURL;

        modal.classList.add("is-visible");
        modal.setAttribute("aria-hidden","false");

        document.body.classList.add("nava-modal-open");

        requestAnimationFrame(() => {

            nameField.focus();

        });

    }

    function closeModal(){

        modal.classList.remove("is-visible");
        modal.setAttribute("aria-hidden","true");

        document.body.classList.remove("nava-modal-open");

        if(activeButton){

            activeButton.focus();

        }

    }

    document.querySelectorAll(".nava-enquiry-button").forEach(button=>{

        button.addEventListener("click",()=>{

            openModal(button);

        });

    });

    closeButton.addEventListener("click",closeModal);

    overlay.addEventListener("click",closeModal);

    document.addEventListener("keydown",(event)=>{

        if(event.key==="Escape" && modal.classList.contains("is-visible")){

            closeModal();

        }

    });

});